export default "__VITE_ASSET__ieWzOWL6__"